import classNames from 'classnames';

interface Props {
  role?: string | null;
  className?: string;
}

const ROLE_LABELS: Record<string, string> = {
  admin: 'ADMIN',
  mod: 'MOD',
};

export const CommunityRoleBadge: React.FC<Props> = ({ role, className }) => {
  if (!role || !ROLE_LABELS[role]) return null;
  return (
    <span
      className={classNames(
        'community-role-badge',
        `community-role-badge--${role}`,
        className,
      )}
      title={`Community ${ROLE_LABELS[role].toLowerCase()}`}
    >
      {ROLE_LABELS[role]}
    </span>
  );
};
